export default "__VITE_ASSET__uYFvCPps__"